__turbopack_context__.v({
  "columnTitle": "list-view-module__2JPb-W__columnTitle",
  "items": "list-view-module__2JPb-W__items",
  "slot": "list-view-module__2JPb-W__slot",
  "slotLevel": "list-view-module__2JPb-W__slotLevel",
  "slots": "list-view-module__2JPb-W__slots",
  "slotsWrapper": "list-view-module__2JPb-W__slotsWrapper",
});
